import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useSEO } from "@/hooks/use-seo";
import {
  ReviewTableOfContents, StickyReviewHeader, ProsConsHeroBlock,
  ResponsibleGamingChecklist, AuthorBylineCard, UpdateDateLine,
} from "@/components/CasinoReviewTemplate";
import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  Clock, Mail, MessageCircle, Globe, Calendar, Lock,
  Users, Trophy, Zap
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo5 from "@assets/logos_extracted/5.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://record.discasinoaffiliates.com/_kTMXKwmZsM88TL4kmJ7MEGNd7ZgqdRLk/1/?pg=1";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const depositMethods = [
  "Apple Pay", "Google Pay", "Bitcoin", "Bitcoin Cash", "Ethereum",
  "Litecoin", "XRP", "USDT", "Mastercard", "Visa",
  "MiFinity", "Interac", "Sofort", "PicPay", "PIX",
];

const withdrawalMethods = [
  "Apple Pay", "Google Pay", "Bitcoin", "Bitcoin Cash", "Ethereum",
  "Litecoin", "XRP", "USDT", "Mastercard", "Visa",
  "MiFinity", "Interac", "Sofort", "PicPay", "PIX",
];

const providers = "NetEnt, Novomatic, Nolimit City, Apricot (Microgaming), Evolution Gaming, Pragmatic Play, Red Tiger Gaming, Betsoft Gaming, Big Time Gaming, Playson, GameArt, Habanero, 1X2 Gaming, High 5 Games, Betgames, Smartsoft Gaming, Fantasma Games, Platipus, Mancala Gaming, G Games, NetGaming, Spribe, OneTouch, TrueLab Games, King Midas, Mascot Gaming, SlotMill, Onlyplay, PGsoft (Pocket Games Soft), VoltEnt, JVL, OctoPlay, Fugaso, Felix Gaming, Skywind Group, Caleta Gaming, Peter & Sons, Fazi, Live88, 3 Oaks Gaming, Air Dice, Gamzix, Kalamba Games, Zillion Games, TopSpin Games, 7Mojos, Hacksaw Gaming, Bitblox";

const pros = [
  "Štědrý uvítací bonus 200 %",
  "Přes 4 000 her od top vývojářů",
  "Podpora kryptoměn a moderních platebních metod",
  "Nonstop live chat podpora pro kvalitní zákaznický servis",
];

const cons = [
  "Chybí živé přenosy ve sázkové sekci",
  "Není telefonická podpora",
  "Neexistuje VIP program",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>500 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>500 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>Do 24 hodin (krypto/e-peněženky)</span></div>
        <div className={rowClass}><span className={labelClass}>Denní limit výběru:</span><span className={valueClass}>100 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Týdenní limit:</span><span className={valueClass}>250 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Měsíční limit:</span><span className={valueClass}>500 000 Kč</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <div className="flex flex-wrap gap-1.5">{["Apple Pay", "Google Pay", "Bitcoin", "Bitcoin Cash", "Ethereum", "Litecoin", "XRP", "USDT", "Mastercard", "Visa", "MiFinity", "Interac", "Sofort", "PicPay", "PIX"].map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <div className="flex flex-wrap gap-1.5">{["Apple Pay", "Google Pay", "Bitcoin", "Bitcoin Cash", "Ethereum", "Litecoin", "XRP", "USDT", "Mastercard", "Visa", "MiFinity", "Interac", "Sofort", "PicPay", "PIX"].map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 4 000 her</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – vč. slotů pro high-rollery</span></div>
        <div className={rowClass}><span className={labelClass}>Živé stoly:</span><span className={valueClass}>Ano – live dealer games (blackjack, ruleta)</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano – přes 50 sportů</span></div>
        <div className={rowClass}><span className={labelClass}>Živé přenosy:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Demo režim:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Min. sázka:</span><span className={valueClass}>Od 1 centu za spin</span></div>
        <div className={rowClass}><span className={labelClass}>Poskytovatelé her:</span><span className={valueClass}>{providers}</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Dostupné 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@fastslots.com</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano – nepřetržitý provoz</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Igloo Ventures SRL</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://fastslots.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">fastslots.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok otevření:</span><span className={valueClass}>2024</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Igloo Ventures SRL</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan (č. ALSI-1423 l 1005-FI2)</span></div>
        <div className={rowClass}><span className={labelClass}>Rozhraní:</span><span className={valueClass}>11 jazyků vč. češtiny</span></div>
        <div className={rowClass}><span className={labelClass}>Měny:</span><span className={valueClass}>BTC, CAD, CZK, ETH, LTC, NZD, USDT, XRP</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Mobilní verze webu, bez aplikace</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ano"],
      ["Limit sázek:", "Ano"],
      ["Limit ztrát:", "Ano"],
      ["Časový limit hraní:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["Dočasná pauza:", "Ano"],
      ["KYC ověření:", "Ano"],
      ["Demo režim:", "Ano"],
      ["VIP program:", "Ne"],
      ["Telefonická podpora:", "Ne"],
    ];
    return <ResponsibleGamingChecklist items={items} />;
  }
  return null;
}

export default function FastSlotsPage() {
  useSEO({ title: "Fast Slots Recenze 2026 – Bonus až 125 000 Kč + free spiny | HrajBonus", description: "Recenze Fast Slots Casino. Uvítací bonus 200 % až 125 000 Kč + 50 free spinů. Výplaty do 24 hodin, 4000+ slotů. Hodnocení 9.2/10. 18+",
  url: "https://hrajbonus.com/kasina/fastslots", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllDeposit, setShowAllDeposit] = useState(false);
  const [showAllWithdrawal, setShowAllWithdrawal] = useState(false);

  const depositVisible = showAllDeposit ? depositMethods : depositMethods.slice(0, 10);
  const withdrawalVisible = showAllWithdrawal ? withdrawalMethods : withdrawalMethods.slice(0, 10);

  return (
    <>
      <StickyReviewHeader casinoName="Fast Slots" logoSrc={logo5} rating="9.2" ctaUrl={CASINO_URL} />
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo5} alt="Fast Slots logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Fast Slots</h1>
                    <UpdateDateLine date="15/02/2026" authorName="Mykhailo Romaenko" />
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4,5].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                  </div>
                  <span className="text-white font-bold text-xl">9.2</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",       value: "4 000+" },
                    { label: "Minimální vklad", value: "500 Kč" },
                    { label: "Minimální výběr", value: "500 Kč" },
                    { label: "Licence",         value: "Anjouan" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>

                <ProsConsHeroBlock pros={pros} cons={cons} />
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">200 % až 125 000 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 50 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="FastSlots" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              <ReviewTableOfContents />

              {/* Author opinion */}
              <AuthorBylineCard name="Mykhailo Romaenko" initials="MR" photo={mykhailoPhoto} role="Senior Content Writer" score="9.2" date="15/02/2026">
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Fast Slots Casino je svěží a dynamická platforma, která zaujme hlavně hráče hledající štědrý vstupní bonus a kombinaci kasinových her se sportovními sázkami. Zákaznická podpora je dostupná nonstop, platební možnosti moderní a registrace rychlá. Chybějící VIP program a živé přenosy ve sportovní sekci jsou mínus, ale pro majority hráčů nepředstavují reálnou překážku.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AuthorBylineCard>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Intro */}
              <div id="prehled" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  Fast Slots Casino: Nejlepší online místo pro hraní v Česku v roce 2026
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Fast Slots Casino je svěží značka ve světě online her, která spustila provoz v roce 2026 pod taktovkou operátora SIMBA NV. Pyšní se licencí od regulačního úřadu ostrova Anjouan, takže můžete hrát s klidem. Každý, kdo se zaregistruje, se může těšit na parádní uvítací bonus!
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Náš tým zkušených analytiků si tuhle platformu pořádně proklepl ze všech stran. Na webu Fast Slots Casino na vás čeká sbírka přes 4 000 hazardních her od známých vývojářů. A v sázkové kanceláři? Tam si vyberete z víc než 50 sportů a na tisíce sázkových příležitostí!
                </p>

                {/* Ratings table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee] mb-5">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Kritérium</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Hodnocení</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Charakteristika</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Důvěra", "4 / 5", "Mladé kasino, které si ještě nestihlo vybudovat dobrou pověst."],
                        ["Hry", "4 / 5", "Není to největší počet her, některé typy chybí."],
                        ["Bonusy", "3 / 5", "Počáteční bonus je dobrý, zbytek je nerozvinutý."],
                        ["Podpora", "5 / 5", "Kvalitní nepřetržitá podpora."],
                      ].map(([criterion, rating, desc], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-3 font-medium text-gray-900">{criterion}</td>
                          <td className="px-4 py-3 text-[#003da5] font-bold">{rating}</td>
                          <td className="px-4 py-3 text-gray-500 text-xs">{desc}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <a href="#bonusy">
                  <Button variant="outline" className="hraj-btn-light font-semibold gap-2 text-[#003da5]" data-testid="button-bonusy">
                    Přejít na bonusy <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
              </div>

              {/* Why you'll like it */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Proč se bude líbit nováčkům i zkušeným hráčům</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Nováčky Fast Slots potěší díky uvítacímu bonusu 200 % + 50 FS. Další plus pro začátečníky je, že minimální sázka ve většině automatů je velmi přátelská. Hrát můžete už za 1 cent za spin!
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Zkušení hráči ocení přítomnost slotů pro high-rollery. S trochou štěstí vám mohou přinést obrovské výhry.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Jednou z nejoblíbenějších funkcí, které si hráči na platformě Fast Slots velice oblíbili, jsou live dealer games. Tento interaktivní způsob hraní přináší autentický kasinový zážitek přímo do vašeho domova, kde můžete komunikovat s profesionálními dealery v reálném čase. Tato možnost umožňuje hráčům zažít skutečné napětí a strategii stolních her, jako je blackjack nebo ruleta, což přidává další úroveň vzrušení při hraní online.
                </p>
              </div>

              {/* Games */}
              <div id="hry" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Herní nabídka Fast Slots</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Fast Slots má rozsáhlé a vyvážené herní portfolio: automaty, stolní hry, karty, live casino a sportovní sázky. Mezi hlavní výhody kasina Fast Slots patří možnost sports betting.
                </p>
                <div className="space-y-2 mb-5">
                  {[
                    { label: "Bonusy", desc: "Uvítací bonus a další atraktivní bonusy pro nové i stávající hráče." },
                    { label: "Hry", desc: "Solidní herní knihovna od známých vývojářů iGaming softwaru." },
                    { label: "Cashback", desc: "Každý týden dostanete zpět část prohraných peněz." },
                    { label: "Kryptoměny", desc: "Podporují kryptoměny." },
                    { label: "Rozmanitost zábavy", desc: "Mají i sázkovou kancelář s více než 50 sporty." },
                    { label: "Podpora", desc: "Kvalitní zákaznická podpora." },
                  ].map(({ label, desc }) => (
                    <div key={label} className="flex items-start gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <span><span className="font-semibold text-gray-800">{label}:</span> {desc}</span>
                    </div>
                  ))}
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co v katalogu stojí za pozornost:</div>
                  <div className="space-y-2">
                    {[
                      "Přes 4 000 her od 45+ vývojářů včetně Pragmatic Play, Evolution, NetEnt",
                      "Sloty pro high-rollery s vysokými limity sázek",
                      "Live dealer games – blackjack, ruleta v reálném čase",
                      "Sportovní sázky na více než 50 sportů",
                      "Minimální sázka již od 1 centu za spin",
                    ].map(item => (
                      <div key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Fast Slots: Bonusy a akce</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Aby bylo hraní ještě zábavnější, kasino Fast Slots nabízí různé bonusy a promotions. Každá taková nabídka, ať už jde o týdenní cashback nebo uvítací dárek, vám může zvýšit šanci na výhru. Mezi hlavní nabídky patří uvítací balíček, cashback, free spiny a turnaje.
                </p>

                <h3 className="font-bold text-gray-900 text-base mb-3">Co je to uvítací bonus Fast Slots?</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Nováčkům, kteří se zaregistrují, se nabízí uvítací bonus. Ten se skládá z dodatečných 200 % (maximálně 125 000 Kč) k prvnímu vkladu a 50 roztočení zdarma na automatu 2 Wild 2 Die. Stačí vložit aspoň 500 Kč, žádný promo kód nepotřebujete, prostě jen potvrdíte, že bonus chcete.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Uvítací bonus (peněžní část i free spiny) vyžaduje protočení s wagerem x30. Bonusové prostředky musíte protočit do 7 dnů, jinak propadnou. Nejsou žádné limity na maximální výhru, kterou můžete z bonusových prostředků vybrat.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Jak získám uvítací bonus Fast Slots?</div>
                  <ol className="space-y-1.5 text-gray-600 text-sm list-none">
                    {[
                      "Otevřete web kasina Fast Slots a zaregistrujte se.",
                      "Proveďte svůj první vklad ve výši nejméně 500 Kč, abyste získali bonusových 200 % a roztočení zdarma.",
                      "Splňte podmínky protočení na slotech. To vám umožní vybrat výhry z bonusového kreditu.",
                      "Důkladně si prostudujte podmínky bonusové nabídky. To vám umožní naplno využít dárek od kasina.",
                    ].map((step, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                      </li>
                    ))}
                  </ol>
                </div>

                <div className="mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Podmínky bonusu</div>
                  <ul className="space-y-2">
                    {[
                      "Požadavky na protočení: 30× bonus / 30× výhry z free spinů",
                      "Minimální vklad pro aktivaci: 500 Kč",
                      "Platnost bonusu: 7 dní od připsání",
                      "Bez limitu na maximální výběr výher z bonusu",
                      "Free spiny: 50× na automatu 2 Wild 2 Die",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <Trophy className="w-4 h-4 text-[#c9960f] mt-0.5 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-5">
                  <p className="text-gray-700 text-sm leading-relaxed">
                    <span className="font-bold text-[#003da5]">Fast Slots: Bonus bez vkladu</span> – Čistý bonus bez vkladu FastSlots Casino momentálně nenabízí. Na platformě Fast Slots je možné získat dárky i pomocí promo kódů. Pro aktivaci základních bonusů ale nejsou potřeba. Aktuální promo kód najdete v sekci &bdquo;Akce&ldquo; na webu kasina nebo na partnerských/recenzních platformách.
                  </p>
                </div>

                <div className="mt-5 pt-5 border-t border-[#eef1f7]">
                  <div className="font-bold text-gray-900 text-sm mb-3">Pravidelné promoakce</div>
                  <div className="grid sm:grid-cols-2 gap-2">
                    {[
                      "Uvítací balíček 200 % + 50 FS bez limitu na výhru",
                      "Týdenní cashback – část prohraných peněz zpět",
                      "Free spiny v rámci průběžných akcí",
                      "Turnaje s atraktivními cenami",
                      "Wager pouze 30× (nižší než standard na trhu)",
                      "Bez nutnosti promo kódu pro základní bonus",
                    ].map(item => (
                      <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Payments */}
              <div id="platby-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jaké platební metody Fast Slots nabízí?</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Fast Slots nabízí 10 ověřených platebních metod, které usnadňují vklady i výběry – karty, e-peněženky, krypto – a spravujete je v osobním účtu vpravo nahoře. Vklady jsou okamžité, výběry zpracovány do 24 hodin. Žádné poplatky ze strany kasina se neúčtují. Pozor: případný poplatek za konverzi může účtovat platební systém.
                </p>

                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {depositVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {depositMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllDeposit(!showAllDeposit)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllDeposit ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{depositMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="mb-6">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody výběru</div>
                  <div className="flex flex-wrap gap-1.5">
                    {withdrawalVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {withdrawalMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllWithdrawal(!showAllWithdrawal)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllWithdrawal ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{withdrawalMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                {/* Speed table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Způsob platby</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Doba vkladu</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Doba výběru</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Přímý bankovní převod", "Do 3 hodin", "Do 3 dnů"],
                        ["Visa, Mastercard", "Do 3 hodin", "Do 3 dnů"],
                        ["E-peněženky (Interac, MiFinity, Sofort…)", "Do 1 hodiny", "Do 1 hodiny"],
                        ["Google Pay, Apple Pay", "Do 10 minut", "Do 10 minut"],
                        ["Kryptoměny (BTC, LTC, ETH, XRP, USDT)", "Do 10 minut", "Do 10 minut"],
                      ].map(([method, deposit, withdrawal], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-3 font-medium text-gray-900">{method}</td>
                          <td className="px-4 py-3 text-gray-600">{deposit}</td>
                          <td className="px-4 py-3 text-gray-600">{withdrawal}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="mt-4 bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">Limity výběru</div>
                  <div className="grid sm:grid-cols-3 gap-3">
                    {[
                      { label: "Denně", value: "100 000 Kč" },
                      { label: "Týdně", value: "250 000 Kč" },
                      { label: "Měsíčně", value: "500 000 Kč" },
                    ].map(({ label, value }) => (
                      <div key={label} className="text-center">
                        <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                        <div className="text-[#003da5] font-black text-base">{value}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Mobile */}
              <div id="mobilni" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hrajte mobilní verzi na Fast Slots</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  A i když kasino nemá vlastní mobilní aplikaci, web Fast Slots si skvěle rozumí se všemi typy mobilních zařízení. Ať už máte jakýkoli operační systém nebo model telefonu/tabletu, bez problémů se dostanete ke všem funkcím.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    { q: "Vlastní mobilní aplikace", a: "Ne – mobilní web plně dostačuje" },
                    { q: "Kompatibilita se zařízeními", a: "iOS i Android" },
                    { q: "Nutné stahování softwaru", a: "Ne" },
                    { q: "Technologie her", a: "HTML5" },
                    { q: "Stabilita při slabém připojení", a: "Ano" },
                    { q: "Přístup ke všem funkcím", a: "Ano" },
                  ].map(({ q, a }) => (
                    <div key={q} className="flex items-center justify-between gap-2 py-2 border-b border-[#eef1f7] last:border-0">
                      <span className="text-gray-600 text-xs">{q}</span>
                      <span className={`text-xs font-bold flex-shrink-0 ${a === "Ne" ? "text-gray-400" : a.startsWith("Ne –") ? "text-gray-500" : "text-green-600"}`}>{a}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Registration */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jak se zaregistrovat na Fast Slots</h2>
                <p className="text-gray-600 leading-relaxed mb-4">Proces založení účtu na Fast Slots je úplně běžný pro online kasina. Stačí projít těmito kroky:</p>
                <div className="space-y-2.5 mb-5">
                  {[
                    "Otevřete web kasina a klikněte na \u201eSign Up\u201c vpravo nahoře.",
                    "Zadejte svůj e-mail, který teď používáte. Pak si vymyslete heslo a ještě jednou ho zopakujte.",
                    "Zadejte své mobilní číslo v mezinárodním formátu (včetně kódu země).",
                    "Vyplňte jméno, příjmení a datum narození.",
                    "Uveďte svou adresu trvalého bydliště, město, PSČ a zemi.",
                    "Zaškrtněte políčko, že souhlasíte s pravidly kasina.",
                  ].map((step, i) => (
                    <div key={i} className="flex items-start gap-2.5 text-gray-700 text-sm">
                      <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Abyste mohli naplno využít všechno, co platforma nabízí, nezapomeňte si ověřit svůj účet. Bude potřeba nahrát pár dokumentů pro proces KYC (Poznej svého klienta), který se dá zařídit přes speciální formulář poskytnutý technickou podporou.
                </p>
              </div>

              {/* Customer support */}
              <div id="podpora-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora 24/7</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Fast Slots zajišťuje nepřetržitou zákaznickou podporu přes live chat a e-mail. Podpora je hodnocena jako kvalitní s rychlými odezvami. Telefonická linka k dispozici není.
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7, hodnocení 5/5</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@fastslots.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">není k dispozici</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Safety */}
              <div id="zodpovedne-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost a licence</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Fast Slots Casino provozuje svou činnost na základě licence od regulačního úřadu ostrova Anjouan (č. ALSI-1423 l 1005-FI2). Tato licence potvrzuje legálnost, férovost a bezpečnost platformy. Hry pocházejí od certifikovaných vývojářů, veškerá komunikace je šifrována.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    "Licence Anjouan – ověřená legálnost a bezpečnost",
                    "256bitové SSL šifrování všech transakcí",
                    "Hry od certifikovaných vývojářů",
                    "KYC ověření pro ochranu hráčů",
                    "Limity vkladů, sázek a ztrát",
                    "Možnost sebevyloučení",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Final Pros/Cons */}
              <div id="verdikt" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Výhody a nevýhody Fast Slots Casino</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-sm uppercase tracking-wide mb-3">
                      <CheckCircle className="w-4 h-4" /> Výhody
                    </div>
                    <ul className="space-y-2">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold text-base leading-none mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-sm uppercase tracking-wide mb-3">
                      <XCircle className="w-4 h-4" /> Nevýhody
                    </div>
                    <ul className="space-y-2">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold text-base leading-none mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <p className="text-gray-500 text-sm mt-5 leading-relaxed">
                  Je jasné, že kasino má mnohem víc plusů než mínusů. Proto si fast slots casino rychle získává popularitu.
                </p>
              </div>

              {/* Conclusion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <p className="text-gray-700 leading-relaxed">
                  Fast Slots Casino v roce 2026 nabízí svěží přístup k online hraní – štědrý 200% uvítací bonus, solidní herní knihovnu od 45+ vývojářů, sportovní sázení na 50+ sportů a nonstop podporu. Je to dobrá volba pro hráče, kteří chtějí rychlý start s výhodným bonusem a moderními platebními metodami včetně kryptoměn.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full bg-[#003da5] flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">MR</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo5} alt="Fast Slots" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Fast Slots</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4,5].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <span className="text-gray-600 text-xs ml-1">9.2/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-lg">200 % až 125 000 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 50 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe,      label: "Web",          value: "fastslots.com" },
                      { icon: Calendar,   label: "Rok",          value: "2024" },
                      { icon: Lock,       label: "Licence",      value: "Anjouan" },
                      { icon: Users,      label: "Provozovatel", value: "Igloo Ventures SRL" },
                      { icon: Gamepad2,   label: "Počet her",    value: "4 000+" },
                      { icon: Clock,      label: "Podpora",      value: "24/7 Live chat" },
                      { icon: CreditCard, label: "Min. vklad",   value: "500 Kč" },
                      { icon: Zap,        label: "Výplaty",      value: "Do 10 min (krypto)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="fastslots" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/onlyspins" className="text-[#003da5] hover:underline" data-testid="review-link-onlyspins">OnlySpins</a>
              {" · "}
              <a href="/kasina/golden-panda" className="text-[#003da5] hover:underline" data-testid="review-link-golden-panda">Golden Panda</a>
              {" · "}
              <a href="/kasina/instant-casino" className="text-[#003da5] hover:underline" data-testid="review-link-instant-casino">Instant Casino</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
